
/* CSS */
import shared from '../styles/shared.module.css';
import styles from './AboutPage.module.css';

/* Components */
import AboutCard from '../components/cards/AboutCard';

/* Data import */
import { ABOUT_DATA } from '../data/aboutData';
import { TEAM_DATA } from '../data/teamData';

const AboutPage = () => {
    return (
        <div className={styles.aboutPage}>
            {/* Page header */}
            <section className={shared.heroHeader}>
                {/* Page title */}
                <h1 className={shared.heroTitle}>About Us</h1>
                <p className={shared.heroSubtitle}>Get to know your TravelBuddy!</p>
            </section>

            {/* About TravelBuddy Section */}
            <section className={styles.aboutCardsSection}>
                {ABOUT_DATA.map((feature, index) => (
                    <div
                        key={feature.id}
                        className={styles.stickyCardWrapper}
                        style={{ top: `${100 + (index * 40)}px` }} // STACKING MAGIC: Offset each card slightly
                    >
                        <AboutCard
                            {...feature}
                        />
                    </div>
                ))}
            </section>

            {/* About Team Section */}
            <section className={styles.teamSection}>
                <div className={styles.teamTitle}>The Team</div>
                <p className={styles.teamSubtitle}>Get to know us behind the scene!</p>

                <div className={styles.teamMemberSection}>
                    {TEAM_DATA.map((teamMember) => (
                        <div
                            key={teamMember.id}
                            className={styles.teamMemberWrapper}
                        >
                            <img
                                className={styles.teamMemberPicture}
                                src={teamMember.picture}
                                alt={teamMember.title}
                                loading="lazy"
                                decoding="async"
                                onError={(e) => { e.currentTarget.style.display = 'none' }}
                            />
                            <div className={styles.teamMemberTitle}>{teamMember.title}</div>
                            <div className={styles.teamMemberDescription}>{teamMember.description}</div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default AboutPage;
